import React from "react";
import { FieldValues, Path } from "react-hook-form";
import { useFormContext } from "@hawkins/forms";
import { Input } from "@hawkins/components";

import { parseCreditCard } from "../../../utils";

interface CreditCardInputFormControlProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  requirementType?: "required-star" | "optional";
  tabIndex?: number;
  style?: React.CSSProperties;
}

export function CreditCardInputFormControl<T extends FieldValues>({
  name,
  label,
  requirementType,
  tabIndex,
  style,
  ...props
}: CreditCardInputFormControlProps<T>) {
  const { watch, setValue } = useFormContext<T>();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawInput = e.target.value;

    const inputValue = rawInput.replace(/\s+/g, "");

    setValue(name, inputValue as any, { shouldValidate: true });
  };

  const value = watch(name);

  return (
    <Input
      name={name}
      onChange={handleInputChange}
      value={parseCreditCard(value).formatted}
      fullWidth
      label={label}
      requirementType={requirementType}
      tabIndex={tabIndex}
      style={style}
      {...props}
    />
  );
}
